import { useTranslation } from "react-i18next";
import { IconMail } from "@tabler/icons-react";
import { stats } from "@/content/stats";
const WHATSAPP_URL = 'https://wa.me/886910811426';
const LINE_URL = 'https://liff.line.me/1645278921-kWRPP32q/?accountId=477lqifx';
const DISCORD_URL = 'https://discord.gg/H6McMYzJJJ';

const AboutSection = ({ className }: { className?: string }) => {

  const { t } = useTranslation();

  return (
    <section className={`py-4 md:py-16 bg-slate-50 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-10 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-8 md:mb-10">
            {t('about.title')}
          </h2>
          <div className="text-slate-800 text-base text-left md:text-lg">
            {(t('about.description', { returnObjects: true }) as string[]).map((paragraph, index) => (
              <p className="text-base md:text-lg text-slate-600 mx-4 mb-6 md:mx-auto max-w-xl" key={index}>
                {paragraph.replace('{{users}}', Math.floor(stats.users / 10000) + ' 萬').replace('{{usersEn}}', (Math.floor(stats.users / 1000) * 1000 / 1000) + 'k+ ')}
              </p>
            ))}
          </div>

          <div className="py-6 flex flex-col items-start max-w-xl mx-4 md:mx-auto">
            <h2 className="text-lg md:text-xl font-semibold border-l-4 border-sky-500 pl-4 py-0 mb-8 text-slate-900">{t('success.help.title')}</h2>
            <p className="text-slate-600 mb-2 text-base md:text-lg text-left">
              {t('success.help.contact')}
            </p>
            <p className="text-sm md:text-base text-slate-600 flex items-center gap-2 mb-6 border border-slate-200 rounded-lg p-2 bg-slate-100">
              <IconMail size={24} className="text-slate-600" />
              contact@clarymind.com
            </p>
            <p className="text-slate-600 mb-4 text-base md:text-lg">
              {t('success.help.otherChannels')}
            </p>
            <div className="flex items-center gap-2.5">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src="/brands/whatsapp.svg"
                  alt="WhatsApp"
                  className="w-10 h-10 rounded-lg"
                />
              </a>
              <a
                href={DISCORD_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src="/brands/discord.jpg"
                  alt="Discord"
                  className="w-10 h-10 rounded-lg"
                />
              </a>
              <a
                href={LINE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity"
              >
                <img
                  src="/brands/line.png"
                  alt="LINE"
                  className="w-10 h-10 rounded-lg"
                />
              </a>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;
